// extracted by mini-css-extract-plugin
export default {"mode":"V1JWG21p_iXxnu8JZWna"};